<script>
  import { _ } from "svelte-i18n";
</script>

<div class="additional-label">{$_("additionalContent")}</div>

<style>
  .additional-label {
    padding: 4px 12px;
    background: #f3f3f4;
    border: 1px solid #e0e8f6;
    color: #5a5f6d;
    font-size: 10px;
    font-weight: 600;
    line-height: 18px;
    border-radius: 30px;
  }
</style>
